import { AdjustPenalties } from "./adjust-penalties";
import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";
import { clockString } from "./util";

export class SetMainClock extends Handler {
    private tmpClock: number;

    constructor() {
        super();
        this.tmpClock = 0;
    }

    boot(): void {
        // Set main clock always starts from zero
        // however it displays the current clock when you come in

        this.tmpClock = 0;

        display.line1("MAIN CLOCK -SET");
        this.showClock(clock.getMainClockVal());
    }

    showClock(val: number): void {
        display.line2(
            `CURR  ${clockString(val, {
                withTenths: true,
            })}`
        );
    }

    toMillis(): number {
        let x = this.tmpClock;

        const tenths = x % 10;
        x = Math.floor((x /= 10));

        const secs = x % 100;
        x = Math.floor((x /= 100));

        const mins = x;

        return (mins * 60 + secs) * 1000 + tenths * 100;
    }

    onKeypad(num: number): void {
        this.tmpClock = (this.tmpClock * 10 + num) % 100000;
        const millis = this.toMillis();
        this.showClock(millis);
    }

    onClear(): void {
        if (this.tmpClock == 0) {
            clock.popHandler();
        } else {
            this.tmpClock = 0;
            this.showClock(0);
        }
    }

    onEnter(): void {
        const newMillis = this.toMillis();

        if (scoreboard.hasPenalties()) {
            const diff = newMillis - clock.getMainClockVal();
            clock.setHandler(new AdjustPenalties(diff));
        } else {
            clock.popHandler();
        }

        clock.setMainClockVal(newMillis);
    }
}
